import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { LLMConfigurationDto } from 'src/core/models/llm/llm-configuration.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { CrudService } from 'src/core/services/crud/crud.service';

@Component({
    selector: 'ca-open-ai-settings',
    templateUrl: './open-ai-settings.component.html',
    styleUrls: ['./open-ai-settings.component.scss'],
    standalone: false
})
export class OpenAiSettingsComponent implements OnInit {
  openAiSettingsForm: FormGroup;
  openAiSettingDtos: ConfigurationSettingsDto[] = [];
  llmConfigurations: LLMConfigurationDto[];

  private readonly settingKeyLLMConfigurationId = 'OpenAI.LLMConfigurationId';

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private crudService: CrudService,
    private localizationService: LocalizationService
  ) {
    this.crudService
      .get<LLMConfigurationDto>(LLMConfigurationDto, {
        filters: [],
        sorters: [],
        skipCount: 0,
        maxResultCount: 9999,
      })
      .subscribe(response => {
        this.llmConfigurations = response.items;
      });

    let llmConfigurationId;

    if (this.config.getSetting(this.settingKeyLLMConfigurationId)) {
      llmConfigurationId = Number(this.config.getSetting(this.settingKeyLLMConfigurationId));
    }

    this.openAiSettingsForm = fb.group({
      llmConfigurationId: [llmConfigurationId],
    });
  }

  ngOnInit(): void {}

  onSubmitOpenAiSettings() {
    if (this.openAiSettingsForm.invalid) {
      return;
    }

    this.openAiSettingDtos = new Array();

    this.openAiSettingDtos.push({
      settingName: this.settingKeyLLMConfigurationId,
      settingValue: this.openAiSettingsForm.get('llmConfigurationId').value?.toString(),
    });

    this.settingService.saveSetting(this.openAiSettingDtos).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
